import { PageTemplate } from "../../templates/PageTemplate";
import { PolicySectionList } from "../../legal/PolicySectionList";
import { legalReviewItems, termsSections } from "../../../content/legal";
import { LEGAL_OWNER_NAME, PRODUCT_NAME } from "../../../lib/legal/config";

export function TermsPage() {
  return (
    <PageTemplate
      id="terms-page"
      header={{
        kicker: "Terms",
        title: `${PRODUCT_NAME} Terms of Use`,
        description: `${PRODUCT_NAME} is operated by ${LEGAL_OWNER_NAME}. These Terms define the limited license to use the platform, platform ownership boundaries, user responsibilities, and key risk allocations for the current product.`,
      }}
    >
      <section className="rounded-[1.75rem] border border-black/10 bg-brand-review/20 p-6">
        <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-brand-muted">
          Review flags
        </p>
        <ul className="mt-4 space-y-3 list-disc pl-5">
          {legalReviewItems.map((item) => (
            <li key={item} className="text-sm text-brand-muted leading-relaxed">
              {item}
            </li>
          ))}
        </ul>
      </section>

      <div className="mt-8">
        <PolicySectionList sections={termsSections} />
      </div>
    </PageTemplate>
  );
}
